import { render, staticRenderFns } from "./Stockview.vue?vue&type=template&id=155ee90a&"
import script from "./Stockview.vue?vue&type=script&lang=js&"
export * from "./Stockview.vue?vue&type=script&lang=js&"
import style0 from "./Stockview.vue?vue&type=style&index=0&id=155ee90a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports